// cspell:disable
import {type EmptyObject} from 'react-hook-form'
import {Method, SimpleAPI} from '../../SimpleAPI'

export type ContactSalesLeadIndustry = 'startup' | 'ecommerce' | 'other'

export type ContactSalesExpectedBalanceSize =
  | 'under100K'
  | 'between100KAnd1M'
  | 'between1MAnd10M'
  | 'between10MAnd50M'
  | 'over50M'

export type ContactSalesMonthlySalesVolume =
  | 'under50K'
  | 'between50KAnd200K'
  | 'between200KAnd1M'
  | 'between1MAnd5M'
  | 'over5M'

export type ContactSalesParams = {
  name: string
  email: string
  website: string
  investors?: string[]
  industry: ContactSalesLeadIndustry
  expectedBalanceSize?: ContactSalesExpectedBalanceSize
  monthlySalesVolume?: ContactSalesMonthlySalesVolume
  comments?: string
  campaign?: string
  source?: string
  medium?: string
  term?: string
  content?: string
  referrerUrl?: string
  firstName?: string
  lastName?: string
  lastVisitedPage?: string
}

export class ContactSales extends SimpleAPI<EmptyObject, ContactSalesParams> {
  revalidate = 'client-only' as const
  method = Method.POST

  getPath() {
    return '/contact/sales'
  }

  protected async getMockResponse() {
    return {}
  }
}
